import { z } from "zod";

/**
 * LinkNodeSchema - Content Schema for Link Node
 *
 * Link nodes represent clickable hyperlinks.
 */
export const LinkNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("link"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  children: z.array(z.any()), // Array of child nodes (usually TextNode)
  url: z.string(),
  title: z.string().optional(),
  target: z.enum(["_blank", "_self", "_parent", "_top"]).optional(),
  rel: z.string().optional(),
}).strict();

export type LinkNode = z.infer<typeof LinkNodeSchema>;
